import { render, staticRenderFns } from "./ghPage.vue?vue&type=template&id=e228e898&"
import script from "./ghPage.vue?vue&type=script&lang=js&"
export * from "./ghPage.vue?vue&type=script&lang=js&"
import style0 from "./ghPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports